export default __webpack_public_path__ + "static/media/cp_geo_mz.4c696fa4.svg";